/* ═══════════════════════════════════════
   KGC SHOW — SHOPIFY THEME JAVASCRIPT
   kgc-theme.js
═══════════════════════════════════════ */

(function () {
  'use strict';

  // ── MOBILE NAV TOGGLE ──
  const navToggle = document.getElementById('nav-toggle');
  const navLinks  = document.getElementById('nav-links');

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen);
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!navToggle.contains(e.target) && !navLinks.contains(e.target)) {
        navLinks.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        navLinks.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ── SMOOTH SCROLL FOR ANCHOR LINKS ──
  document.querySelectorAll('a[href^="#"], .scroll-to').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 64;
        const top = target.getBoundingClientRect().top + window.scrollY - navH - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // ── CART TOAST ──
  const toast = document.getElementById('cart-toast');

  function showToast(msg, duration = 3000) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => toast.classList.remove('show'), duration);
  }

  window.KGCTheme = { showToast };

  // ── AJAX ADD-TO-CART (collection page) ──
  document.querySelectorAll('.merch-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const variantId = form.querySelector('input[name="id"]').value;
      const origText  = btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) throw new Error('Cart error');

        btn.textContent = 'Added ★';
        showToast('Added to cart ★');

        // Refresh cart count in nav
        const cartRes = await fetch('/cart.js');
        const cart    = await cartRes.json();
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent    = cart.item_count;
          countEl.style.display  = cart.item_count > 0 ? '' : 'none';
        }

        setTimeout(() => {
          btn.textContent = origText;
          btn.disabled    = false;
        }, 2200);

      } catch {
        btn.textContent = 'Try again';
        btn.disabled    = false;
      }
    });
  });

  // ── STICKY NAV SHADOW ──
  const nav = document.getElementById('site-nav');
  if (nav) {
    const onScroll = () => {
      nav.style.boxShadow = window.scrollY > 20
        ? '0 4px 24px rgba(0,0,0,0.5)'
        : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── GALLERY ITEMS FADE IN ──
  if ('IntersectionObserver' in window) {
    const items = document.querySelectorAll('.gallery-item, .ep-card, .merch-card');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity  = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    items.forEach(el => {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.45s ease, transform 0.45s ease';
      io.observe(el);
    });
  }

})();
